/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */

export const port = process.env.PORT || 3000;
export const host = process.env.WEBSITE_HOSTNAME || `localhost:${port}`;

// default locale is the first one
export const locales = ["pl-PL", "en-EN", "de-DE"];

export const databaseUrl = process.env.DATABASE_URL || "sqlite:database.sqlite";

export const analytics = {
  // https://analytics.google.com/
  google: {
    trackingId: process.env.GOOGLE_TRACKING_ID, //process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X
  },
};

export const auth = {
  jwt: { secret: process.env.JWT_SECRET || "React Starter Kit" },

  // https://developers.facebook.com/
  facebook: {
    id: process.env.FACEBOOK_APP_ID || "100413827365555",
    secret:
      process.env.FACEBOOK_APP_SECRET || "1712e9fbcf616ae383727bcded833b35",
  },

  // https://cloud.google.com/console/project
  google: {
    id:
      process.env.GOOGLE_CLIENT_ID ||
      "251410730550-ahcg0ou5mgfhl8hlui1urru7jn5s12km.apps.googleusercontent.com",
    secret: process.env.GOOGLE_CLIENT_SECRET || "Y8yR9yZAhm9jQ8FKAL8QIEcd",
  },

  // https://apps.twitter.com/
  twitter: {
    key: process.env.TWITTER_CONSUMER_KEY || "Ie20AZvLJI2lQD5Dsgxgjauns",
    secret:
      process.env.TWITTER_CONSUMER_SECRET ||
      "KTZ6cxoKnEakQCeSpZlaUCJWGAlTEBJj0y2EMkUBujA7zWSvaQ",
  },
};

export const adminRole = "superadmin";
export const districtAdminRole = "districtadmin";
export const adminEndpoint = "/admin";
export const notFoundImageURL =
  "https://www.raceentry.com/img/Race-Registration-Image-Not-Found.png";



// WEBPACK FOOTER //
// src/config.js